const panes = [
  {
    icon: '📜',
    title: 'A live transcript you can actually read',
    description:
      'Big, not buried in a sidebar. Every word appears as it’s spoken, transcribed in real time on your own AssemblyAI key — so you can stop scribbling quotes and just talk.',
  },
  {
    icon: '📝',
    title: 'A big, focused notepad',
    description:
      'Your own notes, front and center, right next to the transcript. Type the things only you would notice — Claude reads them too, so “what were his three priorities?” gets answered from your notes and the conversation.',
  },
  {
    icon: '🃏',
    title: 'A live support column',
    description:
      'Your in-meeting skills watch the conversation and surface compact, beautifully rendered cards as it needs them — pricing talking points when pricing comes up, an objection counter when the customer pushes back. And a chat that knows the transcript-so-far, for anything you want to ask mid-meeting.',
  },
];

const LiveWorkspace = () => {
  return (
    <section className="workspace" id="live">
      <div className="section-container">
        <p className="overline overline--center">DURING THE MEETING</p>
        <h2 className="section-title">Your second brain, on screen</h2>
        <p className="section-subtitle">
          One window, three panes: the conversation as it happens, your notes beside it, and
          Claude working along both. Nothing to alt-tab to, nothing to remember to check.
        </p>

        <div className="workspace-grid">
          {panes.map((p, i) => (
            <div key={i} className="workspace-card">
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>

        <div className="workspace-note mono">
          You stay in the conversation. Claude keeps the receipts.
        </div>
      </div>
    </section>
  );
};

export default LiveWorkspace;
